// extracted by mini-css-extract-plugin
export default {"hintModal":"Sync2AdsManagerBtn_hintModal__NN-ii","syncBtn":"Sync2AdsManagerBtn_syncBtn__yCu6h"};